import {setEcommerceCookieData} from '@utils/cookies';

import {emitYmEvent} from './helpers/ymEvent';

/**
 * in addition to sending ecommerce events, it also sets a cookie
 * that vk-store-web uses to pass list and index into its events;
 * see: https://gitlab.corp.mail.ru/RuStore-Web/vk-store-web/-/blob/master/src/utils/analytics/ecommerceData.ts
 */
export const emitEcommerceSelectAppEventWithCookie = ({
  appId,
  packageName,
  listName,
  position,
  cookieDomain,
}: {
  appId?: number;
  packageName: string;
  listName: string;
  position: number;
  cookieDomain: string;
}) => {
  setEcommerceCookieData(
    {packageName, listName, listPosition: position},
    cookieDomain,
  );

  emitYmEvent('ecommerce_select_item');

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: 'select_item',
    ecommerce: {
      items: [
        {
          item_name: packageName,
          item_id: appId ?? null,
          price: 0,
          item_brand: null,
          item_category: null,
          item_category_2: null,
          item_list_name: listName,
          index: position,
          quantity: 1,
        },
      ],
    },
  });
};
